import type { FolderResultsQuery } from '@/types';

/**
 * The query string of a results list. It is part of the URL and not axios `params` on purpose: the request
 * interceptor (`./index.ts`) cancels an in-flight GET to the same URL, and without the query in it, switching sort,
 * filter or page quickly would cancel the request before it.
 *
 * `sortBy` and `sortDir` go together or not at all; empty filter values are left out. Whether a column may be
 * sorted or filtered is the caller's to decide (it has the schema) — this only writes what it is given.
 */
export function buildFolderResultsQueryString({
  groupId,
  limit,
  offset,
  sortBy,
  sortDir,
  filters,
}: FolderResultsQuery): string {
  const params = new URLSearchParams({ groupId: String(groupId) });
  if (limit !== undefined) params.set('limit', String(limit));
  if (offset !== undefined) params.set('offset', String(offset));
  if (sortBy && sortDir) {
    params.set('sortBy', sortBy);
    params.set('sortDir', sortDir);
  }
  for (const [columnKey, value] of Object.entries(filters ?? {})) {
    if (value !== '') params.set(columnKey, value);
  }
  return params.toString();
}
